export default "__VITE_ASSET__u6U4ys4y__"